const LIST_AUCTION_CITY = [
  {
    key: '',
    label: 'Kota Lelang',
    value: '',
  },
  {
    key: '1',
    label: 'SURABAYA',
    value: 'SURABAYA',
  },
  {
    key: '2',
    label: 'JAKARTA',
    value: 'JAKARTA',
  },
  {
    key: '3',
    label: 'BANJARMASIN',
    value: 'BANJARMASIN',
  },
  {
    key: '4',
    label: 'BANDUNG',
    value: 'BANDUNG',
  },
  {
    key: '5',
    label: 'MEDAN',
    value: 'MEDAN',
  },
  {
    key: '6',
    label: 'PALEMBANG',
    value: 'PALEMBANG',
  },
  {
    key: '7',
    label: 'MAKASSAR',
    value: 'MAKASSAR',
  },
  {
    key: '8',
    label: 'PAPUA',
    value: 'PAPUA',
  },
  {
    key: '9',
    label: 'PEKANBARU',
    value: 'PEKANBARU',
  },
  {
    key: '10',
    label: 'BALIKPAPAN',
    value: 'BALIKPAPAN',
  },
  {
    key: '11',
    label: 'JAMBI',
    value: 'JAMBI',
  },
  {
    key: '12',
    label: 'PONTIANAK',
    value: 'PONTIANAK',
  },
  {
    key: '13',
    label: 'SANGATA',
    value: 'SANGATA',
  },
  {
    key: '14',
    label: 'BATAM',
    value: 'BATAM',
  },
  {
    key: '15',
    label: 'BALI',
    value: 'BALI',
  },
  {
    key: '16',
    label: 'SAMARINDA',
    value: 'SAMARINDA',
  },
  {
    key: '17',
    label: 'SUKABUMI',
    value: 'SUKABUMI',
  },
]

export default LIST_AUCTION_CITY